import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BookingPackageType } from '@products/models/booking.model';
import { LoadProductService } from '@products/services/load-product.service';
import { PackageProductBookingActions } from '@store/products/booking/product/package/package-booking.actions';
import { BookingSmartPromotionActions } from '@store/products/booking/smart-promotion/booking-smart-promotion.actions';
import { ProductSelectionActions } from '@store/products/product-selection/product-selection.actions';
import { PackageProductActions } from '@store/products/product.actions';
import { PackageStatusActions } from '@store/products/status/package/package-status.actions';
import { map } from 'rxjs';

export const setInitialPackageIndexStatus$ = createEffect(
  (actions$ = inject(Actions), loadProductService = inject(LoadProductService)) =>
    actions$.pipe(
      ofType(
        ProductSelectionActions.setInitialProductSelectionList,
        ProductSelectionActions.setPreferredProductSelectionList
      ),
      map(() => {
        const latestAddedInitialPackageIndex = loadProductService.getAndResetLastAddedInitialPackageIndex();
        return PackageStatusActions.setInitialPackageIndexStatus(latestAddedInitialPackageIndex);
      })
    ),
  { functional: true }
);

export const setPackageIndexStatus$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(PackageProductBookingActions.setPackageProductInBookingList),
      map(({ bookingProductTypes }) => {
        return PackageStatusActions.setPackageIndexStatus(bookingProductTypes as BookingPackageType[]);
      })
    ),
  { functional: true }
);

export const setPackageLoadingStatus$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(
        PackageProductActions.setPackageBooking,
        PackageProductActions.removePackageBooking,
        PackageProductBookingActions.setPackageProductInBookingList,
        PackageProductBookingActions.removePackageFromBookingList,
        BookingSmartPromotionActions.setBookedProductsPromoCodeDiscount,
        BookingSmartPromotionActions.removeBookedProductsPromoCodeDiscount
      ),
      map((action) => {
        const productActionTypes: string[] = [
          PackageProductActions.setPackageBooking.type,
          PackageProductActions.removePackageBooking.type
        ];

        const isPackageLoading = productActionTypes.includes(action.type);

        return PackageStatusActions.setIsPackageLoadingStatus(isPackageLoading);
      })
    ),
  { functional: true }
);
